import { gql } from '@apollo/client';

export const CREATE_FACILITY = gql`
    mutation createFacility($facility: CreateFacilityInput!) {
        company {
            facility {
                create(input: $facility) {
                    id
                    facilityCode
                }
            }
        }
    }
`;
